module.exports = __webpack_public_path__ + "img/board_logo.c923fff8.png";